<template>
  <div class="w-full xl:px-10 mx-auto py-10 profile-page">
    <section class="container mx-auto lg:px-12 xl:px-16 my-5 w-full flex items-center flex-col md:flex-row lg:flex-row xl:flex-row">
      <div
        class="w-full md:w-1/4 md:flex lg:flex xl:flex flex-col justify-center items-center p-8"
      >
        <img class="w-16 mx-auto" src="/storage/image/heart.png" alt />
        <p class="text-jblue-primary text-center font-semibold px-4 text-base py-3">
          <v-runtime-template
            :template="
              `<div>${$t('messages.general.heart_logo_message')}</div>`
            "
          ></v-runtime-template>
        </p>
      </div>
      <div class="w-full md:w-3/4 px-6 lg:px-6 xl:px-6">
        <PhotoCarouselWrapper :isMyProfile="true" :userData="user" :pictures="profilePictures"></PhotoCarouselWrapper>
      </div>
    </section>

    <template>
      <div class="container mx-auto pt-10 lg:px-12 xl:px-16" v-if="moreprofiles.length !== 0">
        <p
          class="mb-6 text-xl text-center text-jblue-primary"
        >{{ $t('messages.general.contacts_to_see_message', { contacts: moreprofiles.length }) }}</p>
        <div class="flex justify-center">
          <router-link class="flex justify-around flex-wrap" to="/search">
            <div class="flex justify-center items-center">
              <template v-for="(pro, index) in moreprofiles.slice(0,4)">
                <img
                  :key="index"
                  v-if="pro.picture"
                  class="object-cover w-16 h-16 mx-2 rounded-full"
                  :src="pro.picture"
                  alt
                />
                <img
                  :key="index"
                  v-else
                  src="/storage/image/placeholder-user.jpg"
                  alt
                  class="object-cover w-16 h-16 mx-2 rounded-full"
                />
              </template>
            </div>
            <div class="flex items-center justify-start h-12 text-xl px-2 h-full text-jblue-primary font-bold">
              <p>+ {{ moreprofiles.length }} {{ $t('messages.general.more') }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </template>

    <div v-if="user && (user.subscription_status !== 'active' || user.with_gift)">
      <banner-subscribe-inline />
    </div>

    <section class="container lg:px-12 xl:px-16 mt-10 mx-auto">
        <section class="w-full my-6 flex flex-col flex-wrap md:flex-no-wrap">
          <div
            class="flex h-full flex-row text-left"
          >
            <div class="flex text-sm sm:text-base justify-between items-center md:block bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10 w-1/3">
                <h2
                  class="font-bold text-white"
                >{{$t('messages.general.profile_tables.description')}}</h2>
            </div>
            <div class="flex text-sm sm:text-base justify-between items-center md:block bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10 w-1/3">
              <h2
                class="font-bold flex items-center flex-no-wrap"
                :class="[user.profile.gender == 'female' ? 'text-jpink-secondary' : 'text-blue-200']"
              > <i class="text-base sm:text-xl font-fold pr-2" :class="[user.profile.gender == 'female' ? 'icon-woman' : 'icon-man']"></i> {{$t('messages.general.profile_tables.about_me_table.me', {name:  user.profile.first_name})}}</h2>
            </div>
            <div class="flex text-sm sm:text-base justify-between items-center md:block bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10 w-1/3">
              <h2
                class="font-bold flex items-center flex-no-wrap"
                :class="[user.profile.gender === 'female' ? 'text-blue-200' : 'text-jpink-secondary']"
              ><i class="icon-fav text-base sm:text-xl font-fold pr-2"></i> {{$t('messages.general.profile_tables.about_me_table.ideal_couple', {name:  user.profile.first_name})}}</h2>
            </div>
          </div>

          <div class="content-questions">
              <div class="flex item-even text-jblue-primary">
                <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center font-bold">{{ $t('messages.user_profile.about_me.age.label') }}</div>
                <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center">{{ $t('messages.user_profile.about_me.age.years', { years: user.profile.age }) }}</div>
                <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center">{{ $t('messages.user_profile.about_my_couple.age_range.range', { from: user.profile.start_age, to: user.profile.end_age } ) }}</div>
              </div>
              <div
                class="flex item-even text-jblue-primary"
                v-for="(question, i) in aboutQuestions"
                :key="i"
              >
              <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center font-bold">{{question.question[locale]}}</div>
              <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center">{{question.answer[locale]}}</div>
              <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center">{{question.answerIdealCouple[locale]}}</div>
              </div>
          </div>
        </section>

        <section class="w-full my-4 flex flex-col flex-wrap md:flex-no-wrap">
          <div
            class="h-full flex flex-row text-left"
          >
            <div class="flex justify-between text-sm sm:text-base items-center md:block bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10 w-1/3">
              <h2
                class="font-bold text-white"
              >{{$t('messages.general.profile_tables.description')}}</h2>
            </div>
            <div class="flex justify-between text-sm sm:text-base items-center md:block bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10 w-1/3">
              <h2
                class="font-bold flex items-center flex-no-wrap"
                :class="[user.profile.gender == 'female' ? 'text-jpink-secondary' : 'text-blue-200']"
              ><i class="text-base sm:text-xl font-fold pr-2" :class="[user.profile.gender == 'female' ? 'icon-woman' : 'icon-man']"></i> {{$t('messages.general.profile_tables.my_personality_table.me', {name:  user.profile.first_name})}}</h2>
            </div>
            <div class="flex justify-between text-sm sm:text-base items-center md:block bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10 w-1/3">
              <h2
                class="font-bold flex items-center flex-no-wrap"
                :class="[user.profile.gender === 'female' ? 'text-blue-200' : 'text-jpink-secondary']"
              ><i class="icon-fav text-base sm:text-xl font-fold pr-2"></i> {{$t('messages.general.profile_tables.my_personality_table.ideal_couple', {name:  user.profile.first_name})}}</h2>
            </div>
          </div>

          <div class="content-questions">
              <div
                class="flex item-even text-jblue-primary"
                v-for="(question, i) in personalityQuestions"
                :key="i"
              >
              <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center font-bold">{{question.question[locale]}}</div>
              <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center">{{question.answer[locale]}}</div>
              <div class="w-1/3 p-2 text-sm sm:text-base md:p-6 md:py-3 md:pl-10 flex items-center">{{question.answerIdealCouple[locale]}}</div>
              </div>
          </div>
        </section>

        <section class="w-full my-8 flex flex-wrap md:flex-no-wrap">
          <div class="w-full">
            <div class="flex justify-center flex-wrap md:flex-no-wrap h-full">
              <div
                class="w-full md:w-1/2 item-even"
                v-for="(question, index) in profileQuestions.questions"
                :key="question.id"
              >
                <div class="w-full ">
                  <div
                    class="flex justify-between items-center bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10"
                  >
                    <h2
                      class="font-bold flex text-sm sm:text-base items-center flex-no-wrap text-blue-200"
                      v-if="index === 0"
                    ><i class="text-base sm:text-xl font-fold pr-2" :class="[user.profile.gender == 'female' ? 'icon-woman' : 'icon-man']"></i> {{ question.title[locale] }}</h2>
                    <h2
                      class="font-bold flex text-sm sm:text-base items-center flex-no-wrap"
                      v-else
                      :class="[user.profile.gender == 'female' ? 'text-blue-200' : 'text-jpink-secondary']"
                    ><i class="icon-fav text-base sm:text-xl font-fold pr-2"></i>{{ question.title[locale] }}</h2>
                  </div>
                  <div class="text-jblue-primary  text-sm sm:text-base p-2 md:p-6 md:py-3 md:pl-10 italic">
                    <read-more
                      v-if="user.revision !== 'pending'"
                      v-bind:more-str="$t('messages.general.see_more')"
                      v-bind:text="(question.answer[0] || {}).value ? question.answer[0].value : `-`"
                      link="#"
                      v-bind:less-str="$t('messages.general.see_less')"
                      :max-chars="350"></read-more>
                      <span v-else-if="user.revision === 'pending'">{{$t('messages.general.revision_pending')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="w-full my-8 flex flex-wrap md:flex-no-wrap">
          <div class="w-full">
            <div class="flex justify-center flex-wrap md:flex-no-wrap h-full">
              <div
                class="w-full md:w-1/2 item-even"
                v-for="(question) in spititualQualities"
                :key="question.id"
              >
                <div class="w-full ">
                  <div
                    class="flex justify-between items-center bg-jblue-primary p-2 text-left md:p-6 md:py-3 md:pl-10"
                  >
                    <h2
                      class="font-bold flex text-sm sm:text-base items-center flex-no-wrap text-blue-200"
                    >{{ question.title[locale] }}</h2>
                  </div>
                  <div class="text-jblue-primary text-sm sm:text-base p-2 md:p-6 md:py-3 md:pl-10 italic">
                    <read-more
                      v-if="user.revision !== 'pending'"
                      v-bind:more-str="$t('messages.general.see_more')"
                      v-bind:text="(question.answer[0] || {}).value ? question.answer[0].value : `-`"
                      link="#"
                      v-bind:less-str="$t('messages.general.see_less')"
                      :max-chars="350"></read-more>
                    <span v-else-if="user.revision === 'pending'">{{$t('messages.general.revision_pending')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VRuntimeTemplate from "v-runtime-template";
import _ from 'lodash';
import BannerSubscribeInline from '@/components/BannerSubscribeInline';
import PhotoCarouselWrapper from "@/components/PhotoCarouselWrapper";

export default {
  name: "ProfileAboutMe",
  layout: "platform",
  components: {
    VRuntimeTemplate,
    PhotoCarouselWrapper
  },
  data: () => ({
    personalityQuestions: [],
    aboutQuestions: [],
    profileQuestions: [],
    firstColumnTwoLinesElements: [],
    firstColumnTwoLinesElements2: [],
    profilePictures: [],
    spititualQualities: [],
    coupon_one_month: process.env.MIX_COUPON_ONE_MONTH,
    coupon_three_months: process.env.MIX_COUPON_THREE_MONTHS,
    coupon_fifty: process.env.MIX_COUPON_FIFTY_PERCENT
  }),
  computed: {
    ...mapState("answers", ["answers", "answers_user"]),
    ...mapState("locale", ["locale"]),
    ...mapState("auth", ["user"]),
    ...mapState("profiles", ["moreprofiles"])
  },
  async created() {
    await this.listAnswers();
    await this.showAnswers();
    await this.moreFriends();

    this.orderQuestions(this.answers);

    const pics = _
      .chain(this.user)
      .get('pictures', [])
      .filter(picture => picture.status === 'approved')
      .value();

    this.profilePictures = [
      ...pics
    ];

    for (let i = 0; i < (10 - pics.length); i++) {
      this.profilePictures.push({ id: Math.floor(Math.random() * 100000), url: '/storage/image/placeholder-user.jpg' });
    }

    this.spititualQualities = _
      .chain(this.answers_user)
      .get('spiritual_qualities.subcategories', [])
      .find(sub => sub.key === 'general-spiritual-qualities')
      .get('questions', [])
      .filter(question => [43, 48].includes(question.id))
      .value();
  },
  methods: {
    ...mapActions("answers", ["listAnswers", "showAnswersUsers"]),
    ...mapActions("profiles", ["moreFriends"]),
    itemsHeight(question, locale, column, row, tableId) {
      this.$nextTick(() => {
        if (column === 0) {
          const isTitleTwoLines = question.title[locale].length > 37;
          isTitleTwoLines
            ? tableId === 1
              ? this.firstColumnTwoLinesElements.push(row)
              : this.firstColumnTwoLinesElements2.push(row)
            : "";
          let isDescTwoLines = false;
          if (question.answer[0]) {
            if (question.answer[0].option) {
              if (window.innerWidth <= 1388 && window.innerWidth >= 1050)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 27;
              if (window.innerWidth >= 768 && window.innerWidth <= 1049)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 16;
              if (window.innerWidth >= 1389 && window.innerWidth <= 1826)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 41;
              if (window.innerWidth >= 1827)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 50;
            }
          }
          isDescTwoLines
            ? tableId === 1
              ? this.firstColumnTwoLinesElements.push(row)
              : this.firstColumnTwoLinesElements2.push(row)
            : "";
          if (isTitleTwoLines || isDescTwoLines) {
            return true;
          }
        } else if (column === 1) {
          const isTitleTwoLines = question.title[locale].length > 37;
          let isDescTwoLines = false;
          if (question.answer[0])
            if (question.answer[0].option) {
              if (window.innerWidth <= 1388 && window.innerWidth >= 1050)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 27;
              if (window.innerWidth >= 768 && window.innerWidth <= 1049)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 16;
              if (window.innerWidth >= 1389 && window.innerWidth <= 1826)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 38;
              if (window.innerWidth >= 1827)
                isDescTwoLines =
                  question.answer[0].option.option[locale].length > 50;
            }
          if (tableId === 1) {
            if (this.firstColumnTwoLinesElements.includes(row)) return true;
          } else {
            if (this.firstColumnTwoLinesElements2.includes(row)) return true;
          }
          if (isTitleTwoLines || isDescTwoLines) {
            this.$nextTick(() => {
              const el = document.getElementById(`${tableId}-0-${row}`);
              if (el) {
                el.classList.add("box-height");
                return true;
              }
            });
            return true;
          }
        }
      });
    },
    toggleDropdown(e) {
      const { target } = e;
      const selector = target.closest(".trigger-dropdown-about");
      if (selector.classList.contains("active")) {
        selector.classList.remove("active");
        return;
      }
      if (selector) {
        Array.from(
          document.querySelectorAll(".trigger-dropdown-about")
        ).forEach(item => item.classList.remove("active"));
        selector.classList.add("active");
      }
    },
    showAnswers() {
      this.about_answers = this.answers.filter(
        answer => answer.key === "about-you"
      );
      this.couple_answers = this.answers.filter(
        couple => couple.key === "ideal-couple"
      );
    },
    orderQuestions(data) {
      const subcategories = data.map(item => item.subcategories);
      const personality = this.pairDataByKey(subcategories, "personality");
      const description = this.pairDataByKey(subcategories, "description");
      const lifestyle = this.pairDataByKey(subcategories, "lifestyle");
      const profile = this.pairDataByKey(subcategories, "profile")[0];
      const personalInformation = this.pairDataByKey(
        subcategories,
        "general-about-you"
      );
      const idealCoupleLanguages = this.pairDataByKey(
        subcategories,
        "Languages"
      );
      const idealCoupleEducationCouple = this.pairDataByKey(
        subcategories,
        "education-couple"
      );

      const removeQuestion = question =>
        question.title[this.locale] !== "Do you have pets?" &&
        question.title[this.locale] !== "¿Tiene mascotas?" &&
        question.title[this.locale] !== "¿Tiene Mascotas?" &&
        question.title[this.locale] !== "Education" &&
        question.title[this.locale] !== "Educación" &&
        question.title[this.locale] !==
          "How honest do you consider yourself?" &&
        question.title[this.locale] !== "¿Cuán honesto(a) te consideras?" &&
        question.title[this.locale] !== "¿Cuań honesto(a) se considera?" &&
        question.title[this.locale] !==
          "How often do you connect to social media?" &&
        question.title[this.locale] !==
          "¿Cada cuanto te conectas a redes sociales?" &&
        question.title[this.locale] !== "Other languages" &&
        question.title[this.locale] !== "Otro idioma";

      const aboutData = {
        questions: [
          ...description[0].questions,
          ...personalInformation[0].questions,
          ...lifestyle[0].questions
        ].filter(q => removeQuestion(q)),
        questionsIdealCouple: [
          ...description[1].questions,
          ...idealCoupleLanguages[1].questions,
          ...idealCoupleEducationCouple[1].questions,
          ...lifestyle[1].questions
        ].filter(q => removeQuestion(q))
      }

      aboutData.questions.sort((a, b) =>
        a.order > b.order ? 1 : -1
      );
      aboutData.questionsIdealCouple.sort((a, b) =>
        a.order > b.order ? 1 : -1
      );

      const personalityData = {
        questions: personality[0].questions,
        questionsIdealCouple: personality[1].questions
      }

      this.aboutQuestions = this.formatQuestionsData(aboutData);
      this.personalityQuestions = this.formatQuestionsData(personalityData);
      this.profileQuestions = profile;
    },
    formatQuestionsData(data= []) {
      return data.questions.map((question, index) => ({
          question: question.title,
          answer: question.answer[0]
                  ? question.answer[0].option
                  ? question.answer[0].option.option
                  : "-"
                  : "-",
          answerIdealCouple: data.questionsIdealCouple[index].answer[0]
                            ? data.questionsIdealCouple[index].answer[0].option
                            ? data.questionsIdealCouple[index].answer[0].option.option
                            : "-"
                            : "-"
        }));
    },
    pairDataByKey(data = [], key) {
      return data.map(item => item.find(sub => !!sub.key.includes(key)));
    },
    activeClass(index) {
      if (!(index++ % 2)) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
.profile-page {
  @media screen and(max-width: 1024px) {
    padding-top: 55px;
  }
}

#readmore {
  color: #0669f9;
}

.border-content {
  border-left: solid 1px #cbd5e0;
  border-right: solid 1px #cbd5e0;
}
.item-even:nth-child(even) {
  background-color: #F9FAFF;
}
.item-even:nth-child(odd) {
  background-color: #EDF2FF;
}

@media only screen and (max-width: 767px) {
  .trigger-dropdown-about {
    border-bottom: 1px solid transparent;
    transition: all 0.5s ease-in-out;
    &.active {
      border-bottom: 1px solid #0669f9;
      & ~ .content-questions {
        max-height: 3000px;
      }
    }
  }
}

.drop-arrow {
  font-size: 0.6em;
  color: #1d42b1;
  padding-left: 1em;
}

.box-height {
  min-height: 5rem;
}
</style>
